/// <reference types="./ChangelogQueryGenerator.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ok } from '@dossierhq/core';
import { createSqliteSqlQuery, } from '@dossierhq/database-adapter';
import {} from '../QueryFunctions.js';
import { addConnectionOrderByAndLimit, addConnectionPagingFilter, } from '../utils/ConnectionUtils.js';
export function generateGetChangelogEventsQuery(database, query, paging, entity) {
    const queryBuilder = createSqliteSqlQuery();
    const { sql } = queryBuilder;
    const reverse = !!query.reverse;
    sql `SELECT e.id, e.uuid, e.type, e.created_at, s.uuid AS created_by, sv.version FROM events e`;
    sql `JOIN subjects s ON e.created_by = s.id`;
    sql `LEFT JOIN schema_versions sv ON e.schema_versions_id = sv.id`; // only available on schema events
    if (entity) {
        sql `JOIN event_entity_versions eev ON eev.events_id = e.id`;
        sql `JOIN entity_versions ev ON eev.entity_versions_id = ev.id`;
    }
    sql `WHERE`;
    addQueryFilters(queryBuilder, query, entity);
    const pagingFilterResult = addConnectionPagingFilter(database, sql, paging, 'int', reverse, (sql) => sql `e.id`);
    if (pagingFilterResult.isError())
        return pagingFilterResult;
    addConnectionOrderByAndLimit(sql, paging, reverse, (sql) => sql `e.id`);
    return ok(queryBuilder.query);
}
export function generateGetChangelogTotalCountQuery(query, entity) {
    const queryBuilder = createSqliteSqlQuery();
    const { sql, removeTrailingWhere } = queryBuilder;
    sql `SELECT COUNT(*) AS count FROM events e`;
    if (entity) {
        sql `JOIN event_entity_versions eev ON eev.events_id = e.id`;
        sql `JOIN entity_versions ev ON eev.entity_versions_id = ev.id`;
    }
    sql `WHERE`;
    addQueryFilters(queryBuilder, query, entity);
    removeTrailingWhere();
    return ok(queryBuilder.query);
}
function addQueryFilters({ sql, addValueList }, query, entity) {
    if (query.createdBy) {
        sql `AND e.created_by = (SELECT id FROM subjects WHERE uuid = ${query.createdBy})`;
    }
    if (entity) {
        sql `AND ev.entities_id = ${entity.entityInternalId}`;
    }
    if (query.types && query.types.length > 0) {
        sql `AND e.type IN ${addValueList(query.types)}`;
    }
}
//# sourceMappingURL=ChangelogQueryGenerator.js.map